import { useEffect, useState } from "react";
import CenterModal from "../../../components/CenterModal";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MinibusAccessPopup = ({
  open,
  setOpen,
  organisationName,
  submitting,
  onSubmit,
}) => {
  const [operatesMinibus, setOperatesMinibus] = useState(null);
  const [minibusCount, setMinibusCount] = useState(null);
  const [renewalMonth, setRenewalMonth] = useState("");

  useEffect(() => {
    if (!open) return;

    setOperatesMinibus(null);
    setMinibusCount(null);
    setRenewalMonth("");
  }, [open]);

  const submitForm = (event) => {
    event.preventDefault();
    onSubmit({
      operates_minibus: operatesMinibus,
      minibus_count:
        operatesMinibus && minibusCount !== null && minibusCount !== ""
          ? Number(minibusCount)
          : null,
      renewal_month: renewalMonth || null,
    });
  };

  const optionClassName = (selected) =>
    `flex min-h-[62px] flex-1 items-center gap-4 rounded-lg border px-4 text-left transition focus:outline-none focus:ring-2 focus:ring-sky-400 ${
      selected
        ? "border-sky-400 bg-sky-50 text-slate-900"
        : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
    }`;

  return (
    <CenterModal
      open={open}
      setOpen={setOpen}
      title="Tell us about your school's minibuses"
      width="md"
      showHeader={false}
    >
      <form onSubmit={submitForm} className="px-1 pb-2 sm:px-5 sm:pb-4">
        <div className="flex items-start gap-4">
          <div>
            <h2 className="mt-2 text-2xl font-bold text-[#201E5F] sm:text-3xl">
              Tell us about your school&apos;s minibuses
            </h2>
            <p className="mt-1 text-sm text-slate-500">
              Please answer a few quick questions to help us tailor our services
              to your school.
            </p>
            {organisationName && (
              <span className="mt-4 inline-block rounded-md bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700">
                {organisationName}
              </span>
            )}
          </div>
        </div>

        <fieldset className="mt-7">
          <legend className="mb-2 font-semibold text-slate-800">
            Do you operate a school minibus?
          </legend>
          <div className="flex flex-col gap-3 sm:flex-row">
            {[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ].map((option) => (
              <button
                key={option.label}
                type="button"
                className={optionClassName(operatesMinibus === option.value)}
                onClick={() => setOperatesMinibus(option.value)}
                aria-pressed={operatesMinibus === option.value}
              >
                <span
                  className={`flex h-6 w-6 items-center justify-center rounded-full border-2 ${
                    operatesMinibus === option.value
                      ? "border-sky-400"
                      : "border-slate-300"
                  }`}
                >
                  {operatesMinibus === option.value && (
                    <span className="h-3 w-3 rounded-full bg-sky-400" />
                  )}
                </span>
                <span className="font-medium">{option.label}</span>
              </button>
            ))}
          </div>
        </fieldset>

        {operatesMinibus && (
          <div className="mt-6">
            <label
              htmlFor="minibus-count"
              className="mb-2 block font-semibold text-slate-800"
            >
              How many minibuses does your school operate?{" "}
              <span className="text-red-500">*</span>
            </label>
            <input
              id="minibus-count"
              type="number"
              min="1"
              value={minibusCount ?? ""}
              onChange={(event) => setMinibusCount(event.target.value)}
              className="w-full rounded-lg border border-slate-300 px-4 py-3 focus:border-sky-400 focus:outline-none focus:ring-1 focus:ring-sky-400"
            />
          </div>
        )}

        {operatesMinibus && (
          <div className="mt-6">
            <label
              htmlFor="minibus-renewal-month"
              className="mb-2 block font-semibold text-slate-800"
            >
              When is your minibus insurance due for renewal?
            </label>
            <select
              id="minibus-renewal-month"
              value={renewalMonth}
              onChange={(event) => setRenewalMonth(event.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 focus:border-sky-400 focus:outline-none focus:ring-1 focus:ring-sky-400"
            >
              <option value="">Select a month</option>
              {MONTHS.map((month) => (
                <option key={month} value={month.toLowerCase()}>
                  {month}
                </option>
              ))}
              <option value="unknown">Unknown</option>
            </select>
            <p className="mt-1 text-xs text-slate-500">
              Choose Unknown if you&apos;re unsure.
            </p>
          </div>
        )}

        <div className="mt-7 border-t border-slate-200 pt-5">
          <p className="mb-4 text-sm text-slate-500">
            You only need to complete this once.
          </p>
          <button
            type="submit"
            disabled={operatesMinibus === null || submitting}
            className="w-full rounded-md bg-sky-500 px-5 py-3 font-bold text-white transition hover:bg-sky-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {submitting ? "Submitting..." : "Submit and continue"}
          </button>
        </div>
      </form>
    </CenterModal>
  );
};

export default MinibusAccessPopup;
